import React from 'react';
import Icon from '../../components/Icon';

import './_resume.scss';

const ResumeHeader = () => {
  const resumeBasic = process.env.RESUME_BASIC;
  const resumeModern = process.env.RESUME_MODERN;

  return (
    <section className="resume--section">
      <div className="rb-about-text">
        <div className="resume-title">Jody Boucher</div>
        <div className="resume-subtitle">Software Developer</div>
        <div className="resume-buttons">
          <a
            className="resume-button"
            target="_blank"
            rel="noopener noreferrer"
            href={`/${resumeBasic}`}
          >
            <Icon type="IconDownload" className="resume-icon-download" height="16" width="16" />
            PDF (traditional format)
          </a>
          <a
            className="resume-button"
            target="_blank"
            rel="noopener noreferrer"
            href={`/${resumeModern}`}
          >
            <Icon type="IconDownload" className="resume-icon-download" height="16" width="16" />
            PDF (modern format)
          </a>
        </div>
      </div>
    </section>
  );
};

export default ResumeHeader;



// WEBPACK FOOTER //
// ./src/pages/resume/_Header.js